/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { postSensitiveWordAnalyze } from "../../funcs/postSensitiveWordAnalyze.js";
import { PostSensitiveWordAnalyzeRequest$zodSchema } from "../../models/postsensitivewordanalyzeop.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: PostSensitiveWordAnalyzeRequest$zodSchema,
};

export const tool$postSensitiveWordAnalyze: ToolDefinition<typeof args> = {
  name: "text-post-sensitive-word-analyze",
  description: `分析敏感词

分析单个或多个关键词的敏感程度，返回标准化风险标签与置信度结果。

> [!VIP]
> 本API基于先进的分析模型，提供三级缓存策略和并发处理能力。

## 功能概述

- **模型驱动**: 使用先进的分析模型进行语义分析。
- **高性能**: 采用三级缓存策略（持久化存储 → 统一缓存 → 模型分析），确保高频请求的响应速度。
- **并发支持**: 支持批量并发处理，单次最多可分析100个关键词。
- **标准标签**: 返回 \`label\` 字段，明确区分 \`sensitive\` 与 \`normal\`。
- **分类清晰**: 返回 \`category\` 字段，用于标识具体风险类别。
- **置信度输出**: 返回 \`confidence\` 字段，范围为0.0到1.0。

## 响应字段说明

| 字段 | 类型 | 说明 |
|------|------|------|
| \`results\` | array | 分析结果对象的数组。 |
| \`results[].k\` | string | 您在请求中提供的原始关键词。 |
| \`results[].label\` | string | 核心判断字段：\`sensitive\`(敏感)、\`normal\`(正常)。 |
| \`results[].category\` | string | 风险分类：\`safe\`(安全)、\`threat\`(威胁)、\`porn\`(色情)、\`fraud\`(欺诈)、\`insult\`(辱骂)。 |
| \`results[].confidence\` | number | 当前分类的置信度，范围0.0到1.0。 |
| \`total\` | integer | 本次请求成功分析的关键词总数。 |
      `,
  scopes: ["read"],
  annotations: {
    "title": "",
    "destructiveHint": false,
    "idempotentHint": false,
    "openWorldHint": true,
    "readOnlyHint": true,
  },
  args,
  tool: async (client, args, ctx) => {
    const [result] = await postSensitiveWordAnalyze(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    return formatResult(result.value);
  },
};
